import React from 'react';
import Lottie from "react-lottie";
import animationData from './Flow 2.json';

const LottieAnimation2 = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return <Lottie options={defaultOptions} style={{height:"20vh"}}/>;
};

export default LottieAnimation2;
